import {
  FLAG_LIGHT_VERSION_SORT_FILTER,
  FLAG_LIGHT_VERSION_CARD_VIEW,
} from 'core/common/constants/env'

const isArray = item => Array.isArray(item)

const isFunction = item => typeof item === 'function'

const isObject = item => typeof item === 'object' && Array.isArray(item) === false && item !== null

const isString = item => typeof item === 'string'

const isBoolean = item => typeof item === 'boolean'

const isEmpty = item => {
  if (isArray(item)) {
    return !item.length
  }
  if (isObject(item)) {
    return !Object.keys(item).length
  }
  return !isString(item)
}

const isNumber = item => Number.isFinite(item)

const isLightVersion = [FLAG_LIGHT_VERSION_SORT_FILTER, FLAG_LIGHT_VERSION_CARD_VIEW].some(
  flag => flag === 'true'
)

export { isArray, isEmpty, isFunction, isObject, isString, isBoolean, isNumber, isLightVersion }
